var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"tooltip tooltip-top",attrs:{"data-tooltip":_vm.text}},[_c('dr-icon',{key:"tooltip_2",staticClass:"v-icon",attrs:{"color":"silver","name":"info"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }